import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export function SopStatsTable({ stats, onCellClick }) {
  if (!stats || stats.sites.length === 0) return null;

  return (
    <div className="overflow-auto max-h-80 border border-border rounded-lg" data-testid="sop-stats-table">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="sticky left-0 bg-card">Site</TableHead>
            {stats.years.map((y) => (
              <TableHead key={y} className="text-center">
                {y}
              </TableHead>
            ))}
            <TableHead className="text-center font-semibold">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {stats.sites.map((site) => (
            <TableRow key={site} data-testid={`sop-stats-row-${site}`}>
              <TableCell className="font-medium sticky left-0 bg-card">{site}</TableCell>
              {stats.years.map((year) => {
                const count = stats.matrix[site]?.[year] || 0;
                return (
                  <TableCell key={year} className="text-center p-0">
                    <button
                      type="button"
                      disabled={count === 0}
                      onClick={() => onCellClick(site, year)}
                      className={
                        count > 0
                          ? "w-full h-full py-2 text-xs font-medium hover:bg-accent hover:text-accent-foreground cursor-pointer transition-colors"
                          : "w-full h-full py-2 text-xs text-muted-foreground/40"
                      }
                      data-testid={`sop-stats-cell-${site}-${year}`}
                    >
                      {count || "—"}
                    </button>
                  </TableCell>
                );
              })}
              <TableCell className="text-center font-semibold">{stats.site_totals[site]}</TableCell>
            </TableRow>
          ))}
          <TableRow className="bg-muted/50 font-semibold">
            <TableCell className="sticky left-0 bg-muted/50">Total</TableCell>
            {stats.years.map((year) => (
              <TableCell key={year} className="text-center">
                {stats.year_totals[year]}
              </TableCell>
            ))}
            <TableCell className="text-center" data-testid="sop-stats-grand-total">
              {stats.grand_total}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
}
